const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
    "xmlns:cc": "http://creativecommons.org/ns#",
    "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "xmlns:svg": "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
    width: "5.7274075mm",
    height: "6.1788306mm",
    viewBox: "0 0 5.7274075 6.1788306",
    id: "svg3934",
    "inkscape:version": "0.92.3 (2405546, 2018-03-11)",
    "sodipodi:docname": "timer_icon.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs3928"
  }), /*#__PURE__*/React.createElement("sodipodi:namedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    "inkscape:pageopacity": 0,
    "inkscape:pageshadow": 2,
    "inkscape:zoom": 0.35,
    "inkscape:cx": 10.823447,
    "inkscape:cy": 11.676528,
    "inkscape:document-units": "mm",
    "inkscape:current-layer": "layer1",
    showgrid: "false",
    "inkscape:window-width": 2880,
    "inkscape:window-height": 1674,
    "inkscape:window-x": 0,
    "inkscape:window-y": 60,
    "inkscape:window-maximized": 1
  }), /*#__PURE__*/React.createElement("metadata", {
    id: "metadata3931"
  }, /*#__PURE__*/React.createElement("rdf:RDF", null, /*#__PURE__*/React.createElement("cc:Work", {
    "rdf:about": ""
  }, /*#__PURE__*/React.createElement("dc:format", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dc:type", {
    "rdf:resource": "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dc:title", null)))), /*#__PURE__*/React.createElement("g", {
    "inkscape:label": "Layer 1",
    "inkscape:groupmode": "layer",
    id: "layer1",
    transform: "translate(84.128585,-145.74392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -83.462232,149.3721 c -0.03493,0.0247 -0.300567,0.2159 -0.324909,0.56409 -0.02857,0.41169 0.306917,0.65581 0.324909,0.66851 0.01976,0.0127 0.333022,0.22543 0.324908,0.61172 -0.0071,0.36865 -0.299508,0.56656 -0.324908,0.58279",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.24516609,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1300",
    "inkscape:connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -82.776785,149.3721 c -0.03528,0.0247 -0.300567,0.2159 -0.324909,0.56409 -0.02858,0.41169 0.306917,0.65581 0.324909,0.66851 0.0194,0.0127 0.332669,0.22543 0.324908,0.61172 -0.0074,0.36865 -0.299861,0.56656 -0.324908,0.58279",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.24516609,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1302",
    "inkscape:connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -82.10686,149.3721 c -0.03528,0.0247 -0.300567,0.2159 -0.324909,0.56409 -0.02858,0.41169 0.306917,0.65581 0.324909,0.66851 0.01976,0.0127 0.332669,0.22543 0.324908,0.61172 -0.0074,0.36865 -0.299861,0.56656 -0.324908,0.58279",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.24516609,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1304",
    "inkscape:connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -83.956827,148.56142 c 0.0067,-0.13053 0.101953,-1.50002 1.286933,-2.23697 0.942623,-0.58632 2.227792,-0.55668 3.136195,0.18909 0.974725,0.8001 1.189919,2.15829 0.725664,3.21239 -0.403225,0.91511 -1.294342,1.54658 -2.329392,1.65524",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.34323227,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1306",
    "inkscape:connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -81.26478,146.94534 v 1.70286 h 1.113367",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.34323227,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1308",
    "inkscape:connector-curvature": 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timer_icon.86dd3b7bce55af3b637d61d9d1ab4169.svg";
export { ForwardRef as ReactComponent };